let value = {
  version: process.env.REACT_APP_VERSION,
}

export default function useDataTransform(props, data) {
  return value
}
